var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-h-screen tw-flex tw-justify-center tw-items-center tw-p-4"},[_c('div',{staticClass:"tw-text-center"},[_c('ui-logo',{staticClass:"tw-w-auto tw-mx-auto tw-h-10 lg:tw-h-12"}),_c('div',{staticClass:"tw-mt-4 tw-whitespace-pre-line tw-text-gray-500"},[_vm._v(" "+_vm._s(_vm.$t('errors.api-503'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }